var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 1.29259L5.99992 5.58559L1.70692 1.29259C1.51832 1.11043 1.26571 1.00964 1.00352 1.01192C0.741321 1.0142 0.490508 1.11937 0.3051 1.30477C0.119692 1.49018 0.0145233 1.74099 0.0122448 2.00319C0.00996641 2.26539 0.110761 2.51799 0.292919 2.70659L5.29292 7.70659C5.48045 7.89406 5.73475 7.99938 5.99992 7.99938C6.26508 7.99938 6.51939 7.89406 6.70692 7.70659L11.7069 2.70659C11.8024 2.61435 11.8786 2.504 11.931 2.382C11.9834 2.25999 12.011 2.12877 12.0122 1.99599C12.0133 1.86321 11.988 1.73154 11.9377 1.60864C11.8875 1.48574 11.8132 1.37409 11.7193 1.2802C11.6254 1.18631 11.5138 1.11205 11.3909 1.06177C11.268 1.01149 11.1363 0.986189 11.0035 0.987342C10.8707 0.988496 10.7395 1.01608 10.6175 1.06849C10.4955 1.1209 10.3852 1.19708 10.2929 1.29259V1.29259Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelect);
export default __webpack_public_path__ + "static/media/arrow-select.f1586defcd6e7d360191749e8d16fa32.svg";
export { ForwardRef as ReactComponent };